import { Account, type AccountUser, type Club, ClubPermission } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import ClubPermissionRow from "./ClubPermissionRow";

interface Props {
  accountUser?: AccountUser;
  clubs: Club[];
  permissionsByClub: Record<string, ClubPermission>;
}

const UserPermissionsTable: React.FC<Props> = ({ accountUser, clubs, permissionsByClub }) => {
  const permissionKeys = ClubPermission.displayPermissionKeys({
    funding: Account.current?.hasFeature("funding") === true,
  });

  return (
    <table className="w-full">
      <colgroup>
        <col className="w-[26%]" />
        <col />
        {permissionKeys.map((perm) => (
          <col key={perm} className="w-[14%]" />
        ))}
      </colgroup>

      <thead>
        <tr className="text-xs uppercase text-gray-500 *:px-2">
          <th className="text-left">Club</th>
          <th />
          {permissionKeys.map((perm) => (
            <th key={perm}>{ClubPermission.PermissionLabels[perm]}</th>
          ))}
        </tr>
      </thead>

      <tbody className="divide-y divide-gray-200">
        {clubs.map((club) => (
          <ClubPermissionRow
            key={club.domKey()}
            accountUser={accountUser}
            club={club}
            permission={permissionsByClub[club.uniqueId]}
            permissionKeys={permissionKeys}
          />
        ))}
      </tbody>
    </table>
  );
};

export default ApplicationView(UserPermissionsTable);
